import { Component, OnInit, ViewChild, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { DocumentEditorService } from 'src/app/shared/services/document-editor.service';
import { EditorService, SelectionService, ToolbarService } from '@syncfusion/ej2-angular-documenteditor';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataService } from 'src/app/shared/services/data.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { L10n } from '@syncfusion/ej2-base';
import { LocalizedLabels } from 'src/assets/lib/localizedLabels';
import { loadMessages, locale } from 'devextreme/localization';
import RELocalization from 'src/assets/translations/dx-rich.fr.json';
import { ParamsService } from 'src/app/shared/services/params.service';
import { DocumentsService } from 'src/app/shared/services/documents.service';
import { DocumentFormatApi } from 'devexpress-richedit/lib/model-api/formats/enum';
import { IRicheditComponent } from '@devinforius/i-dx-editor';
import { IButton, TranslateService } from '@devinforius/i-essentials';
import { DocumentTemplate } from 'src/app/shared/models/iCourrier/document-template';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { toMergeFieldsForEditor } from 'src/app/shared/utils/merge-fields-for-editor.util';
L10n.load(LocalizedLabels);

@Component({
  selector: 'app-template-view-modal',
  templateUrl: './template-view-modal.component.html',
  styleUrls: ['./template-view-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ToolbarService, SelectionService, EditorService, DialogService],
})
export class TemplateViewModalComponent implements OnInit {
  public readonly mergeFields = toSignal(this.documentsService.getFusionsField().pipe(map(toMergeFieldsForEditor)), { initialValue: {} });



  @ViewChild('document_editor') public documenteditorcontainer: IRicheditComponent;
  public template: DocumentTemplate;
  public baseUrlDocumentEditor: string;
  public mailId: number;
  public mousePosition: MouseEvent;
  public lang = localStorage.getItem('lang');
  public searchValue = '';
  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    this.mousePosition = event;
  }
  public blob: Blob;
  public arrayCanvas: { page: number; canvas: HTMLCanvasElement }[] = [];

  public timer;

  public titleButtons: IButton[] = [
    {
      text: 'cancel',
      styleClass: 'blue',
      click: () => {
        this.close();
      },
    },
  ];

  constructor(
    public toastr: ToastrService,
    public spinner: NgxSpinnerService,
    public dataService: DataService,
    public dataDialog: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    public documentEditorService: DocumentEditorService,
    public dialog: DialogService,
    public params: ParamsService,
    public documentsService: DocumentsService,
    private translater: TranslateService
  ) {
    if (RELocalization) {
      loadMessages({ fr: RELocalization });
      locale('fr');
    }
  }

  ngOnInit(): void {
    if (this.dataDialog?.data) {
      this.template = this.dataDialog.data.template;
      this.mailId = this.dataDialog.data.mailId;
    }
    this.titleButtons = this.titleButtons.map((button) => ({ ...button, text: this.translater.translate(button.text) }));

    this.transformDocument();
  }

  public close(): void {
    this.ref.close();
  }

  transformDocument(): void {
    this.spinner.show();
    const blob = new Blob([this.template.rtf], { type: 'application/rtf' });

    this.blob = blob;
    if (this.blob) {
      this.loadBlob(this.blob);
    } else {
      this.spinner.hide();
    }
  }

  public loadBlob(blob: Blob): void {
    setTimeout(() => {
      if (this.documenteditorcontainer) {
        this.documenteditorcontainer.rich.openDocument(blob, this.template.description, DocumentFormatApi.Rtf, () => {
          this.spinner.hide();
        });
      }
    }, 2000);
  }

  pageRendered($event): void {
    const $canvas = $event.source.canvas;
    this.arrayCanvas.push({
      page: $event.pageNumber,
      canvas: $canvas,
    });
  }
}
